export class Url {
    static extendSearchParams(uri, key, val) {
        return uri
            .replace(new RegExp("([?&]" + key + "(?=[=&#]|$)[^#&]*|(?=#|$))"), "&" + key + "=" + encodeURIComponent(val))
            .replace(/^([^?&]+)&/, "$1?");
    }
    static serialize(params) {
        return Object.keys(params).map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])).join('&');
    }
}
//# sourceMappingURL=../../src/lib/helper/url.js.map